import { graphHooks } from '@tunasong/graph-lib/react'
import type { Entity } from '@tunasong/schemas'
import type { FC } from 'react'
import { useCallback } from 'react'
import { Properties } from '../properties.js'
import type { PollViewProps } from './types.js'

const EditView: FC<PollViewProps> = props => {
  const { entity: poll } = props

  const updateEntity = graphHooks.useEntityUpdate({ debounceDelay: 1 * 1000 })
  const handleChange = useCallback(
    (partial: Partial<Entity>) => updateEntity(poll.id, partial),
    [poll.id, updateEntity]
  )

  return <Properties element={poll} onChange={handleChange} />
}

export default EditView
